import fectx from 'helper/fectx';

fectx.interceptors.response.use(response => {
  if (
    /* eslint-disable eqeqeq*/
    response.data &&
    response.data.ResultCode == '200' &&
    response.data.InnerData &&
    response.data.InnerData.Code === 'GoPage'
    /* eslint-enable */
  ) {
    window.location.href = response.data.InnerData.GoUrl;
  }

  return response;
});
